import { Link } from "@tanstack/react-router";
import { Image } from "@/components/image";
import { ACTIVITIES__NEW__ } from "@/lib/constants";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionDescription,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "./scaffold";

export function Activities() {
  return (
    <ScaffoldSection>
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Direkt zu</ScaffoldSectionTitle>
          <ScaffoldSectionDescription>
            erlebe unsere Angebote
          </ScaffoldSectionDescription>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            {Object.values(ACTIVITIES__NEW__).map((activity) => (
              <Link
                {...activity.link}
                className="grid gap-2"
                key={activity.key}
              >
                <div className="relative flex aspect-square items-center justify-center overflow-hidden rounded-lg">
                  <Image
                    alt={activity.name}
                    className="absolute inset-0 size-full object-cover object-center"
                    height={180}
                    src={activity.brand.backgroundImage}
                    width={180}
                  />
                  <div className="absolute inset-0 bg-black/50" />
                  <Image
                    alt={activity.name}
                    className="relative size-2/5 object-contain object-center"
                    height={110}
                    src={activity.brand.logo}
                    width={110}
                  />
                </div>
                <span className="text-center text-sm">
                  {activity.shortDescription}
                </span>
              </Link>
            ))}
          </div>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
